import React from 'react';
import LandingBlurb from "./LandingBlurb";
import LandingValueProps from "./LandingValueProps";
import LandingFeaturedSeller from './LandingFeaturedSeller';
import { Link } from 'react-router-dom';
import FeaturedSeller from '../../static/landing/landing-featured-seller.png';

import '../../styles/LandingMain.css';

export default function LandingMain() {
    return (
        <div className="LandingMain">
            <LandingBlurb />
            <LandingValueProps />
            <div className="success-div">
                {Array(5).fill(<h2>Everything you need to be successful on Depop.</h2>)}
                <div className="success-div-overlay">
                </div>
            </div>
            <LandingFeaturedSeller 
            name="sellername"
            sellerImg={FeaturedSeller}
            testimonial={"The amount of growth and new sales I have had since using Salewave" +
            " is incredible. The app is super easy to use and I can access from mobile!"} />
            {/* Eventually should include img prop as well for profile pic of user. */}

            <div className="closing-statement">
                <h1>Join the thousands of happy Depop sellers using Salewave to boost their following and sales!</h1>
                <Link to="/pricing">Get Access Today!</Link>
            </div>
            
        </div>
    )
}